import { CommonModule } from '@angular/common';
import {
  Component,
  ContentChild,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import '@maersk-global/mds-components-core';
import { debounceTime, Subject, switchMap } from 'rxjs';
import { SearchModel } from '../../models';
import { StoreService } from '../../services/store.service';

@Component({
  selector: 'app-search-wrapper',
  templateUrl: './search-wrapper.component.html',
  styleUrl: './search-wrapper.component.scss',
  imports: [RouterOutlet, CommonModule, TranslocoModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SearchWrapperComponent {
  @Input() topRightButtonLabel?: string;
  @Input() topRightButtonIcon: string = 'tray-arrow-up';
  @Input() topRightButtonAppearance: string = 'primary';
  @Input() topRightButtonClick = () => { };
  @Input() filterTags?: string[];
  @Input() searchModel?: SearchModel;
  @Input() initialSearchValue: string = '';
  @Input() tagCleared = (event: Event) => { };
  @Input() onTopRightMenuClick = (event: Event) => { };
  @Input() topRightMenuDisabledOptionsValues: Array<string> = [];
  @Input() topRightMenuButtonDisabled = false;
  @Input() withTopRightMenu = false;
  @Input() searchWithClear = true;
  @Input() onClearSearchClick = (event: Event) => { };
  @Input() rowSelected: boolean = false;
  @Input() selectedRowLength: number = 0;
  @Input() withTopRightMenuHeader = false;
  @Input() topRightMenuHeaderLabel = '';
  @Input() topRightMenuHeaderOptions: Array<string> = [];
  @Input() onTopRightHeaderItemClick = (event: Event) => { };
  @Output() drawerFilterCleared = new EventEmitter<void>();
  @Output() drawerFilterApplied = new EventEmitter<void>();
  @Output() drawerFilterOpened = new EventEmitter<void>();
  @Output() drawerFilterClosed = new EventEmitter<void>();
  @Output() filtersTagCleared = new EventEmitter<void>();
  @Input() extraCssClasses = '';
  @Input() filterTagTooltips: { [tagLabel: string]: string } = {};
  @Input() filtersToApply: any;

  @ViewChild('titleElement', { static: false }) titleElement!: ElementRef;
  isTextOverflowing: boolean = false;

  ngAfterViewInit() {
    this.checkTextOverflow();
  }

  checkTextOverflow() {
    if (this.titleElement) {
      const element = this.titleElement.nativeElement;
      this.isTextOverflowing = element.scrollWidth > element.offsetWidth;
    }
  }

  @ContentChild('filtersPresent', { static: false })
  filtersContent?: ElementRef;
  areFiltersEmpty = true;
  isMenuTopRightOpen = false;
  private searchSubject = new Subject<Event>();
  isPricesPage = false;
  isAccessorialPage = false;
  storeService = inject(StoreService);

  constructor(private router: Router, private route: ActivatedRoute) {
    this.searchSubject
      .pipe(
        debounceTime(600),
        switchMap(async (event) => this.searched(event))
      )
      .subscribe();
    this.isPricesPage = this.router.url.includes('/prices');
    this.isAccessorialPage = this.router.url.includes('/accessorialfees');
  }

  ngAfterContentInit(): void {
    if (this.filtersContent) {
      this.areFiltersEmpty =
        !this.filtersContent.nativeElement.innerHTML.trim();
    }
  }

  private getCurrentRoute(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
  searched(event: Event) {
    const searchedTearm = (event.target as HTMLInputElement).value;
    if (this.searchModel) {
      this.searchModel.searchedTearm(searchedTearm ?? '');
    }
  }

  searchedTrigger(event: Event) {
    this.searchSubject.next(event);
  }

  toggleDrawer = () => {
    const drawer = document.querySelector('mc-drawer');
    if (!drawer) return;
    drawer.open = !drawer.open;
  };

  public onFilterCleared() {
    this.drawerFilterCleared.emit();
  }

  public onFilterApplied() {
    this.drawerFilterApplied.emit();
  }

  public onFilterDrawerOpened() {
    this.drawerFilterOpened.emit();
  }

  public onFilterDrawerClosed() {
    this.drawerFilterClosed.emit();
  }
  public onFilterTagCleared() {
    this.filtersToApply = [];
    this.filtersTagCleared.emit();
  }
}
